import { get, post, put, destroy } from "./base";

const CouponServ = {
    // Get all coupons (Admin)
    index: (params) => get("/coupons", { params }),

    // Get single coupon by ID
    single: (id) => get(`/coupons/${id}`),

    // Create coupon
    create: (payload) => post("/coupons", payload),

    // Update coupon
    update: (id, payload) => put(`/coupons/${id}`, payload),

    // Delete coupon
    remove: (id) => destroy(`/coupons/${id}`),

    // Apply coupon (Buyer)
    apply: (payload) => post("/coupons/apply", payload),

    // Get My Coupons (Buyer)
    getMyCoupons: () => get("/coupons/my-coupons"),

    // Search Buyers (Admin)
    searchBuyers: (params) => get("/coupons/buyers/search", { params }),

    // Send Coupon (Admin)
    sendToBuyers: (id, payload) => post(`/coupons/${id}/send`, payload),

    // --- NEW ENTERPRISE ENDPOINTS ---

    // Preview Coupon
    preview: (payload) => post("/coupons/preview", payload),

    // Clone Coupon (Admin)
    clone: (id) => post(`/coupons/${id}/clone`),

    // Simulate Coupon (Admin)
    simulate: (payload) => post("/coupons/simulate", payload),

    // Get Coupon Usage/Audit History (Admin)
    getUsageHistory: (params) => get("/coupons/usage/history", { params }),
};

export default CouponServ;
